<template>
  <koffietafel />
</template>

<script>
import Koffietafel from '../components/Raadplegen/Koffietafel.vue'

export default {
  name: 'KoffietafelView',
  components: {
    Koffietafel
  }
}
</script>
